<div class="grid grid-cols-1 gap-0 text-center">
  <h5 class="text-2xl mb-1 uppercase">Libro de Reclamaciones</h5>
  <img src="assets/img/restaurant.pe.jpg" alt="" class="w-[180px] mx-auto">
 <!--  <div class="col-start-1 col-end-4">
    <label class="text-2xl">Libro de Reclamaciones</label>
  </div>
  <div class="col-end-9 col-span-4">

  </div> -->
</div>
